import {
  eventTirggerLabels,
  taskTiggerLabels,
  billingTiggerLabels,
  caseTiggerLabels,
  fileTiggerLabels,
  contactTiggerLabels,
  leadTiggerLabels,
  automationModules,
} from 'constants/automationConstants';

const { EVENT_CREATED, EVENT_CANCELLED, EVENT_DATETIME_CHANGED } = eventTirggerLabels || {};

const { NEW_TASK_CREATED, TASK_STATUS_CHANGED } = taskTiggerLabels || {};

const { NEW_PAYMENT_RECEIVED, PAYMENT_REFUNDED, PAYMENT_PAST_DUE, INVOICE_PAST_DUE } = billingTiggerLabels || {};

const { CASE_CREATED, CASE_STATUS_CHANGED, CASE_STAGE_CHANGED, CASE_CLOSED, REVIEW_REQUEST_SENT } = caseTiggerLabels || {};

const { NEW_FILE_CREATED, ESIGANATURE_STATUS_CHANGED, NEW_FILE_UPLOADED } = fileTiggerLabels || {};

const { NEW_CONTACT_CREATED } = contactTiggerLabels || {};

const { LEAD_CREATED, LEAD_STATUS_CHANGED, LEAD_CONVERTED_TO_CASE, LEAD_STAGE_CHANGED } = leadTiggerLabels || {};

const { EVENTS, TASKS, BILLING, CASES, FILES, CONTACTS, LEADS } = automationModules || {};

const eventTriggerAction = {
  label: 'Events',
  items: [
    { label: EVENT_CREATED, code: 'TRIG_EVENT_CREATE', ruleValidationCode: 'EVENT_CREATE', module: EVENTS },
    { label: EVENT_CANCELLED, code: 'TRIG_EVENT_CANCEL', ruleValidationCode: 'EVENT_CANCEL', module: EVENTS },
    {
      label: EVENT_DATETIME_CHANGED,
      code: 'TRIG_EVENT_DATE_TIME_CHANGED',
      ruleValidationCode: 'EVENT_DATE_TIME_CHANGED',
      module: EVENTS,
    },
  ],
};

const taskTriggerAction = {
  label: 'Tasks',
  items: [
    { label: NEW_TASK_CREATED, code: 'TRIG_TASK_CREATE', ruleValidationCode: 'TASK_CREATE', module: TASKS },
    { label: TASK_STATUS_CHANGED, code: 'TRIG_TASK_STATUS_CHANGE', ruleValidationCode: 'TASK_STATUS_CHANGE', module: TASKS },
  ],
};

const billingTriggerAction = {
  label: 'Billing',
  items: [
    { label: NEW_PAYMENT_RECEIVED, code: 'TRIG_PAYMENT_RECEIVE', ruleValidationCode: 'PAYMENT_RECEIVE', module: BILLING },
    { label: PAYMENT_REFUNDED, code: 'TRIG_PAYMENT_REFUND', ruleValidationCode: 'PAYMENT_REFUND', module: BILLING },
    { label: PAYMENT_PAST_DUE, code: 'TRIG_PAYMENT_REQUEST_PASTDUE', ruleValidationCode: 'TRIG_PAYMENT_REQUEST_PASTDUE', module: BILLING },
    { label: INVOICE_PAST_DUE, code: 'TRIG_INVOICE_PASTDUE', ruleValidationCode: 'TRIG_INVOICE_PASTDUE', module: BILLING },
  ],
};

const caseTriggerAction = {
  label: 'Cases',
  items: [
    { label: CASE_CREATED, code: 'TRIG_CASE_DATA_ENTRY', ruleValidationCode: 'CASE_DATA_ENTRY', module: CASES },
    // { label: CASE_STATUS_CHANGED, code: 'TRIG_CASE_STATUS_CHANGE', ruleValidationCode: 'CASE_STATUS_CHANGE', module: CASES },
    //Renamed "Case Status Changed" to "Case Closed" and keeping all other keys as same
    { label: CASE_CLOSED, code: 'TRIG_CASE_STATUS_CHANGE', ruleValidationCode: 'CASE_STATUS_CHANGE', module: CASES },
    { label: CASE_STAGE_CHANGED, code: 'TRIG_CASE_STAGE_CHANGE', ruleValidationCode: 'CASE_STAGE_CHANGE', module: CASES },
    { label: REVIEW_REQUEST_SENT, code: 'TRIG_REVIEW_REQUEST', ruleValidationCode: 'TRIG_REVIEW_REQUEST', module: CASES },
  ],
};

const filesTriggerAction = {
  label: 'Files',
  items: [
    {
      label: NEW_FILE_CREATED,
      code: 'TRIG_FILE_CREATE',
      ruleValidationCode: 'FILE_CREATE',
      module: FILES,
    },
    {
      label: ESIGANATURE_STATUS_CHANGED,
      code: 'TRIG_ESIGN_STATUS_CHANGE',
      ruleValidationCode: 'ESIGN_STATUS_CHANGE',
      module: FILES,
    },
    {
      label: NEW_FILE_UPLOADED,
      code: 'TRIG_FILE_UPLOAD',
      ruleValidationCode: 'FILE_UPLOAD',
      module: FILES,
    },
  ],
};

const contactTriggerAction = {
  label: 'Contacts',

  items: [{ label: NEW_CONTACT_CREATED, code: 'TRIG_CONTACT_CREATE', ruleValidationCode: 'CONTACT_CREATE', module: CONTACTS }],
};

const leadsTriggerAction = {
  label: 'Leads',
  items: [
    { label: LEAD_CREATED, code: 'TRIG_LEAD_CREATE', ruleValidationCode: 'LEAD_CREATE', module: LEADS },
    {
      label: LEAD_STATUS_CHANGED,
      code: 'TRIG_LEAD_STATUS_CHANGE',
      ruleValidationCode: 'LEAD_STATUS_CHANGE',
      module: LEADS,
    },
    {
      label: LEAD_STAGE_CHANGED,
      code: 'TRIG_LEAD_STAGE_CHANGE',
      ruleValidationCode: 'LEAD_STAGE_CHANGE',
      module: LEADS,
    },
    {
      label: LEAD_CONVERTED_TO_CASE,
      code: 'TRIG_LEAD_CONV_CASE',
      ruleValidationCode: 'LEAD_CONV_CASE',
      module: LEADS,
    },
  ],
};

export const groupedTriggers = [
  eventTriggerAction,
  taskTriggerAction,
  billingTriggerAction,
  caseTriggerAction,
  filesTriggerAction,
  contactTriggerAction,
  leadsTriggerAction,
];
